export default __webpack_public_path__ + "static/media/gdsc-banner.29fb337f.svg";